import { ConfigService } from "../../api/config-service";
import { EOSService } from "../../api/eos-service";
import EncryptUtils from "../../utils/EncryptUtils";

const state = {
};

const getters = {};

const actions = {
    async getYears() {
        return await EOSService.makeRequest(ConfigService.getYears())
    },
    async canActiveLock() {
        return await EOSService.makeRequest(ConfigService.canActiveLock())
    },
    async canDeActiveLock() {
        return await EOSService.makeRequest(ConfigService.canDeActiveLock())
    },
    async AutoUpdate() {
        return await EOSService.makeRequest(ConfigService.AutoUpdate())
    },
    async ChangeDb() {
        return await EOSService.makeRequest(ConfigService.ChangeDb())
    },
    async ChangeYearDb() {
        return await EOSService.makeRequest(ConfigService.ChangeYearDb())
    },
    async ChangeTable() {
        return await EOSService.makeRequest(ConfigService.ChangeTable())
    },
    async loadConfig() {
        return await EOSService.makeRequest(ConfigService.loadConfig())
    },
    async saveConfig(context, { saveConfigParams }) {
        //ServerName=sf29&DBName=eos_webkart&DBUserName=sa&DBPassWord=12345678&winPrsDbName=&winPrsDbuser=&winPrsDbPass=&lockserver=192.168.2.11&lockPort=17590&adminpass=.
        var adminPass=EncryptUtils.encryptPassword(saveConfigParams.adminpass)
        //debugger
        var params = new URLSearchParams()
        params.append('ServerName', saveConfigParams.ServerName || '')
        params.append('DBName', saveConfigParams.DBName || '')
        params.append('DBUserName', saveConfigParams.DBUserName || '')
        params.append('DBPassWord', saveConfigParams.DBPassWord || '')
        params.append('winPrsDbName', saveConfigParams.WinPrsDBName || '')
        params.append('winPrsDbuser', saveConfigParams.WinPrsUserName || '')
        params.append('winPrsDbPass', saveConfigParams.WinPrsPassword || '')
        params.append('lockserver', saveConfigParams.LockServer || '')
        params.append('lockPort', saveConfigParams.LockPort || '')
        params.append('adminpass', adminPass || '')
        return await EOSService.makeRequest(ConfigService.saveConfig(params))
    },
    async DeActiveLockByWeb() {
        return await EOSService.makeRequest(ConfigService.DeActiveLockByWeb())
    },
    async ActiveLockByWeb(context, { productCode }) {
        var params = new URLSearchParams()
        params.append('productCode', productCode)
        return await EOSService.makeRequest(ConfigService.ActiveLockByWeb(params))
    },
    async ActiveLockByFile(context, { file }) {
        //console.log(file);
        var data = new FormData()
        data.append('file', file)
        return await EOSService.makeRequest(ConfigService.ActiveLockByFile(data))
    },
    async loadLockAvtivation() {
        return await EOSService.makeRequest(ConfigService.loadLockAvtivation())
    },
    async hasActiveYearDb() {
        return await EOSService.makeRequest(ConfigService.hasActiveYearDb())
    },
    async NeedUpdateDB() {
        return await EOSService.makeRequest(ConfigService.NeedUpdateDB())
    },
    async IsWinkartUpToDate() {
        return await EOSService.makeRequest(ConfigService.IsWinkartUpToDate())
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}